import { useAuth } from '../context/AuthContext';
import AdminDashboard from './admin/AdminDashboard';
import OperatorDashboard from './operator/OperatorDashboard';
import ClientDashboard from './client/ClientDashboard';

/**
 * Pagina dashboard - mostra contenuto in base al ruolo
 */
function DashboardPage() {
  const { user } = useAuth();

  switch (user?.role) {
    case 'admin':
      return <AdminDashboard />;
    case 'operator':
      return <OperatorDashboard />;
    case 'client':
      return <ClientDashboard />;
    default:
      return (
        <div className="text-center py-12">
          <p className="text-muted-foreground">Ruolo non riconosciuto</p>
        </div>
      );
  }
}

export default DashboardPage;
